import { useTranslation } from "react-i18next";

import { useAuth } from "@/shared/stores/useAuth";
import OwnedDeckCardList from "@/cards/common/component/deck-library/OwnedDeckCardList";
import { useDeckCardTalentExpandShare } from "@/cards/common/component/deck-library/useDeckCardTalentExpandShare";
import {
  DEMO_CARD_NAVIGATION,
  getDemoCardIdFromCard,
  mapDemoMainCardResponseToPublishedCard,
} from "@/cards/common/utils/app-deck/ownedDeckCardList.utils";

/** Talent view of their own Demo Cards (cover, episodes, listing, exp creation). */
const DemoCardTalentPage = () => {
  const { t } = useTranslation();
  const { userInfo } = useAuth();
  const { onExpandShare, shareModal } = useDeckCardTalentExpandShare({
    cardKind: "demo",
  });

  return (
    <>
      <OwnedDeckCardList
        deckCardType="Demo_Card"
        viewMode="talent"
        purchaseFilter="all"
        navigation={DEMO_CARD_NAVIGATION}
        titleLabel={t("my_cards", { defaultValue: "My Cards" })}
        showTalentFilter={false}
        injectTalentCreationPage
        enabled={Boolean(userInfo?.id)}
        onExpandShare={onExpandShare}
        deckCardShareKind="demo"
        mapFetchedMainCard={mapDemoMainCardResponseToPublishedCard}
        secondaryUrlParam={{
          key: "demoCardId",
          getValue: (card) => getDemoCardIdFromCard(card),
        }}
      />
      {shareModal}
    </>
  );
};

export default DemoCardTalentPage;
